interface Properties {
  width?: any;
  height?: any;
  color?: string;
  marginRight?: string;
}

const VarianceIcon = ({ width, height, color, marginRight }: Properties) => {
  return (
    <svg
      style={{ marginRight }}
      width={width}
      height={height}
      fill={color}
      viewBox='0 0 22 22'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 0 C7.26 0 14.52 0 22 0 C22 7.26 22 14.52 22 22 C14.74 22 7.48 22 0 22 C0 14.74 0 7.48 0 0 Z '
        fill='transparent'
        transform='translate(0,0)'
      />
      <path
        d='M0 0 C0.33 1.32 0.66 2.64 1 4 C1.66 4 2.32 4 3 4 C3 7.3 3 10.6 3 14 C-4.26 14 -11.52 14 -19 14 C-19 9 -19 9 -17.25 7.19921875 C-16.5075 6.70035156 -15.765 6.20148437 -15 5.6875 C-14.2575 5.17574219 -13.515 4.66398438 -12.75 4.13671875 C-12.1725 3.76160156 -11.595 3.38648438 -11 3 C-10.01 3.99 -9.02 4.98 -8 6 C-4.63408134 4.55746343 -2.48952921 2.66735273 0 0 Z '
        fill='transparent'
        transform='translate(19,8)'
      />
      <path
        d='M0 0 C2.31 0 4.62 0 7 0 C7 2.31 7 4.62 7 7 C6.34 7 5.68 7 5 7 C4.67 6.01 4.34 5.02 4 4 C2.02 5.98 0.04 7.96 -2 10 C-2.598125 9.67 -3.19625 9.34 -3.8125 9 C-6.05386471 7.79212012 -6.05386471 7.79212012 -9 8 C-11.18777466 9.9375006 -11.18777466 9.9375006 -13 12 C-13.66 11.67 -14.32 11.34 -15 11 C-12.69 8.69 -10.38 6.38 -8 4 C-6.68 4.66 -5.36 5.32 -4 6 C-0.87501834 6.3373846 -0.87501834 6.3373846 1.1875 4 C1.785625 3.34 2.38375 2.68 3 2 C2.01 1.34 1.02 0.68 0 0 Z '
        fill={color}
        transform='translate(15,5)'
      />
    </svg>
  );
};

export default VarianceIcon;
